module.exports = __webpack_public_path__ + "static/media/infiniti-street-selected.abff497d.svg";